<template>
  <div id="header">
    <nav
      class="navbar navbar-expand-lg navbar-light topbar static-top shadow-sm bg-white osahan-nav-top px-0 stickynote"
    >
      <div class="container">
        <a href="https://umbrellacolabhome.onrender.com/">
          <img
            class="navbar-brand d-inline-block align-top"
            src="@/assets/images/logo.png"
            height="60"
            alt=""
          />
        </a>
        <ul class="nav-links">
          <li><a href="#">Who We Are</a></li>
          <li><a href="#">Community</a></li>
          <li><a href="#">Resources</a></li>
        </ul>
        <ul class="navbar-nav align-items-center ml-auto">
          <li class="nav-item dropdown">
            <a class="nav-link" href="profile">
              <img
                src="../assets/images/profile.png"
                style="
                  border-radius: 50%;
                  max-width: 25px;
                  max-height: 25px;
                  margin-right: 10px;
                "
              />
              <span class="user-name">Gloria Amaka </span>
            </a>
          </li>
          <button id="menu-toggle" @click="toggleMenu">Menu</button>
        </ul>
      </div>
    </nav>
    <transition>
      <ul v-if="menuIsVisible" id="toggle-dropdown">
        <li><a href="#">Who We Are</a></li>
        <li><a href="#">Community</a></li>
        <li><a href="#">Resources</a></li>
      </ul>
    </transition>
  </div>
</template>
    
<script>
export default {
  data() {
    return {
      menuIsVisible: false,
    };
  },
  methods: {
    toggleMenu() {
      this.menuIsVisible = !this.menuIsVisible;
    },
  },
};
</script>
    
<style scoped>
.nav-links li {
  display: inline-block;
  padding: 0px 20px;
}
.nav-links a {
  transition: all 0.3s ease 0s;
  color: rgba(5, 1, 18, 0.55);
}

a {
  font-size: 14px;
}

button {
  outline: none;
  border: none;
  padding: 8px 12px;
  border-radius: 6px !important;
  text-transform: uppercase;
  font-weight: 600;
  background: #5448e2;
  color: white;
  font-size: 11px
}

#toggle-dropdown li {
  padding: 8px 0;
}

#toggle-dropdown li a {
  display: inline-block !important;
}

.v-enter-from, .v-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.v-enter-active, .v-leave-active {
  transition: all 0.2s ease-out;
}

.v-enter-to, .v-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>